import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./RegistroUsuario.css";
import Select from "react-select";
import { Header1 } from "../../componentes/header/Header1";
import { userOrder } from '../../states/userOrder';
import { ToastContainer, toast } from 'react-toastify';
import { apiGet, apiPost } from '../../utils/api';
import { configShop } from '../../states/configShop';
import Modal from "../Modal/modal";
import AddressAdd from "../Address/AddressAdd";
import ShopAdd from "../Address/ShopAdd";
import DeliveryMethods from "../Address/DeliveryMethods";
import useWindowWidth from "../hooks/useMediaQuery";
import { FaUser, FaEnvelope, FaPhone, FaIdCard, FaHashtag, FaShieldAlt, FaArrowRight, FaTruck, FaStore } from "react-icons/fa";

const RegistroGuests = ({
  enviarInfoOrdenMesa,
  numeroPedidoFinal,
  propiedadesCompany2,
}) => {
  const { dataConfig } = configShop();
  const width = useWindowWidth();
  const btnColor   = dataConfig?.page_menu?.button?.color      ?? "#6C63FF";
  const btnText    = dataConfig?.page_menu?.button?.color_text ?? "#ffffff";
  const colorTitle = dataConfig?.page_menu?.color_text         ?? dataConfig?.color_font ?? "#1A1A2E";
  const colorSub   = dataConfig?.page_menu?.color_description  ?? dataConfig?.color_font_secundary ?? "#5C5C7A";
  const [propiedadesCompany, setPropiedadesCompany] = useState([]);
  const { setDataUser, dataUser } = userOrder();
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [document, setDocument] = useState('');
  const [typeDocument, setTypeDocument] = useState('0');
  const [address, setAddress] = useState();
  const [cityId, setCityId] = useState(0);
  const [cityName, setCityName] = useState();
  const [loading, setLoading] = useState(false);

  const options = [
    { value: 1, label: "Cédula de ciudadanía" },
    { value: 2, label: "NIT" },
    { value: 3, label: "Pasaporte" },
    { value: 4, label: "Cédula de extranjería" },
  ];

  let navigate = useNavigate();

  const guardarInfo = async () => {
    toast.dismiss();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!name || !name.trim()) {
      toast.error("Por favor ingresar Nombre y Apellido", { position: "top-center", autoClose: 4000 });
      return;
    }
    if (!email || email.trim() === "") {
      toast.error("Por favor ingresar Correo", { position: "top-center", autoClose: 4000 });
      return;
    }
    if (!emailPattern.test(email)) {
      toast.error("Por favor ingrese un correo válido", { position: "top-center" });
      return;
    }
    if (!String(phone).trim()) {
      toast.error("Por favor ingresar Teléfono", { position: "top-center", autoClose: 4000 });
      return;
    }
    const phoneNum = parseInt(phone, 10);
    if (isNaN(phoneNum) || phoneNum < 3000000000 || phoneNum > 7000000000) {
      toast.error("Por favor ingrese un teléfono válido", { position: "top-center" });
      return;
    }
    if (typeDocument === "0") {
      toast.error("Por favor seleccione un tipo de documento", { position: "top-center" });
      return;
    }
    if (!document || document === "0") {
      toast.error("Por favor ingrese un número documento", { position: "top-center" });
      return;
    }

    setLoading(true);
    try {
      if (dataUser.deliveryMethod == 2) {
        setDataUser({ name, lastname: name, address, phone, city_name: cityName, type_document: typeDocument, document, email, uuidShop: 'FFFFF' });
        navigate("/detallePago/");
      } else if (dataConfig.delivery_mode == 4) {
        setDataUser({ name, lastname: name, address, city: cityId, phone, city_name: cityName, type_document: typeDocument, document, email, uuidShop: 'FFFFF' });
        navigate("/detallePago/");
      } else {
        const respuestaJSON = await apiPost('/search/address', { city_id: cityId, address, phone });
        if (respuestaJSON.message !== "success") {
          toast.error(respuestaJSON.message, { position: "top-center", autoClose: 5000 });
        } else {
          setDataUser({ name, lastname: name, address, city: cityId, phone, city_name: cityName, type_document: typeDocument, document, email, uuidShop: respuestaJSON.data.id_branchs });
          navigate("/detallePago/");
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (e) => e.preventDefault();

  const selectStyles = {
    container: (p) => ({ ...p, width: "100%" }),
    control: (p, state) => ({
      ...p,
      width: "100%",
      minHeight: "52px",
      borderRadius: "14px",
      border: state.isFocused ? `2px solid ${btnColor}` : "2px solid #EBEBF0",
      background: "#F7F7FA",
      boxShadow: "none",
      paddingLeft: "36px",
      fontSize: "15px",
      "&:hover": { borderColor: btnColor },
    }),
    valueContainer: (p) => ({ ...p, paddingLeft: "4px" }),
    placeholder: (p) => ({ ...p, color: "#AAAAB5", fontSize: "15px" }),
    singleValue: (p) => ({ ...p, color: colorTitle, fontSize: "15px" }),
    menu: (p) => ({ ...p, borderRadius: "12px", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", zIndex: 1100 }),
    option: (p, state) => ({
      ...p,
      background: state.isSelected ? btnColor : state.isFocused ? `${btnColor}18` : "white",
      color: state.isSelected ? btnText : colorTitle,
      fontSize: "15px",
      borderRadius: "8px",
      margin: "2px 4px",
      width: "calc(100% - 8px)",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const obtenerCiudades = async () => {
    const respuesta = await apiGet('/cities');
    setPropiedadesCompany(respuesta.properties);
  };

  useEffect(() => {
    setAddress(dataUser.address);
    setCityId(dataUser.city);
    setCityName(dataUser.city_name);
    setName(dataUser?.name);
    setPhone(dataUser?.phone);
    setEmail(dataUser?.email);
    const savedTypeDoc = localStorage.getItem("guestTypeDocument");
    const savedDoc     = localStorage.getItem("guestDocument");
    if (savedTypeDoc && savedTypeDoc !== '0') setTypeDocument(savedTypeDoc);
    if (savedDoc)                             setDocument(savedDoc);
    obtenerCiudades();
  }, []);

  return (
    <div className="App">
      <div className="containerPrincipal">
        <header className="App-header">
          <Header1 propiedadesCompany={propiedadesCompany} />
        </header>

        <form className="rg-form" onSubmit={onSubmit}>

          {/* Sección: Entrega */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              {/* PLZ-325: en "Pide y Recoge" la seccion es el lugar de recogida, no la entrega. */}
              {dataUser.pickupOnly === true ? <FaStore size={18} color={btnColor} /> : <FaTruck size={18} color={btnColor} />}
              <span className="rg-section-title" style={{ color: colorTitle }}>
                {dataUser.pickupOnly === true ? "Dónde recoges" : "Datos de entrega"}
              </span>
            </div>
            <DeliveryMethods />
          </div>

          {/* Sección: Información personal */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <FaUser size={17} color={btnColor} />
              <span className="rg-section-title" style={{ color: colorTitle }}>
                Información del cliente
              </span>
            </div>

            <div className="rg-field-group">
              <label className="rg-label" style={{ color: colorSub }}>Nombre y apellido</label>
              <div className="rg-input-wrapper">
                <FaUser className="rg-input-icon" style={{ color: btnColor }} />
                <input
                  type="text"
                  className="rg-input"
                  placeholder="Ej: María García"
                  value={name || ''}
                  onChange={(e) => setName(e.target.value)}
                  style={{ "--focus-color": btnColor, color: colorTitle }}
                />
              </div>
            </div>

            <div className="rg-field-group">
              <label className="rg-label" style={{ color: colorSub }}>Correo electrónico</label>
              <div className="rg-input-wrapper">
                <FaEnvelope className="rg-input-icon" style={{ color: btnColor }} />
                <input
                  type="email"
                  className="rg-input"
                  placeholder="ejemplo@correo.com"
                  value={email || ''}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ "--focus-color": btnColor, color: colorTitle }}
                />
              </div>
            </div>

            <div className="rg-field-group">
              <label className="rg-label" style={{ color: colorSub }}>Teléfono</label>
              <div className="rg-input-wrapper">
                <FaPhone className="rg-input-icon" style={{ color: btnColor }} />
                <input
                  type="number"
                  className="rg-input"
                  placeholder="300 000 0000"
                  value={phone || ''}
                  min={1}
                  onChange={(e) => setPhone(e.target.value)}
                  style={{ "--focus-color": btnColor, color: colorTitle }}
                />
              </div>
            </div>
          </div>

          {/* Sección: Documento */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <FaIdCard size={18} color={btnColor} />
              <span className="rg-section-title" style={{ color: colorTitle }}>
                Documento de identidad
              </span>
            </div>

            <div className="rg-field-group">
              <label className="rg-label" style={{ color: colorSub }}>Tipo de documento</label>
              <div className="rg-input-wrapper rg-select-wrapper">
                <FaIdCard className="rg-input-icon" style={{ color: btnColor }} />
                <Select
                  id="tipo-documento"
                  value={options.find(o => String(o.value) === String(typeDocument)) ?? null}
                  options={options}
                  styles={selectStyles}
                  onChange={(e) => {
                    setTypeDocument(e.value);
                    localStorage.setItem("guestTypeDocument", e.value);
                  }}
                  theme={(theme) => ({ ...theme, borderRadius: 14 })}
                  placeholder="Seleccionar tipo"
                />
              </div>
            </div>

            <div className="rg-field-group">
              <label className="rg-label" style={{ color: colorSub }}>Número de documento</label>
              <div className="rg-input-wrapper">
                <FaHashtag className="rg-input-icon" style={{ color: btnColor }} />
                <input
                  type="number"
                  className="rg-input"
                  placeholder="Ej: 1234567890"
                  min={1}
                  value={document}
                  onChange={(e) => {
                    setDocument(e.target.value);
                    localStorage.setItem("guestDocument", e.target.value);
                  }}
                  style={{ "--focus-color": btnColor, color: colorTitle }}
                />
              </div>
            </div>

            <div className="rg-info-box" style={{ background: `${btnColor}12` }}>
              <FaShieldAlt className="rg-info-icon" style={{ color: btnColor }} />
              <div className="rg-info-text">
                <span className="rg-info-title" style={{ color: colorTitle }}>¿Por qué pedimos estos datos?</span>
                <span className="rg-info-desc" style={{ color: colorSub }}>
                  Para cumplir con la ley de <b>facturación electrónica</b>. Tus datos están protegidos y son confidenciales.
                </span>
              </div>
            </div>
          </div>

          <div className="rg-bottom-spacer" />
        </form>

        {/* Botón flotante */}
        <div className="rg-footer-bar">
          <button
            onClick={guardarInfo}
            disabled={loading}
            className="rg-btn-pagar"
            style={{ "--btn-color": btnColor, "--btn-text": btnText }}
          >
            {loading ? (
              <span className="rg-btn-spinner" />
            ) : (
              <>
                <span>Ir a pagar</span>
                <FaArrowRight className="rg-btn-arrow" />
              </>
            )}
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default RegistroGuests;
